<template>
    <v-container id="refvalores-caplp">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>ADMINISTRACION DE REFERENCIAS DE VALOR DE MATRICULA</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row row wrap>
                <v-col cols="12" md="12" lg="12" class="alineaderecha">
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Listar"
                    @click="listarreferencias"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Nueva Referencia"
                    @click="nuevoreferencia"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnasrefe"
                    :items="listareferencias"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idvalorreferencia"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="editar(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editar Referencia</span>
                      </v-tooltip>
                      &nbsp;&nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="abrirvalores(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura"
                          >
                            mdi-counter
                          </v-icon>
                        </template>
                        <span>Valores</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
            fluid
            class="full-height"
            style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
                <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialogvalores" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Valores de la Referencia de Valor de Matrícula
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="red darken-1" text @click="dialogvalores = false">
                  Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <br />
            <v-row row wrap>
              <v-col cols="12" md="12" lg="12" class="alineaderecha">
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Listar"
                  @click="listarvalores"
                  :disabled="!permisolectura"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Nuevo Valor"
                  @click="nuevovalor"
                  :disabled="!permisoescritura"
                >
                  <v-icon dark> mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="12" lg="12">
                <v-data-table
                    :headers="columnasvalores"
                    :items="listavalores"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idvalorreferenciavalor"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="editarvalor(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura || !item.permiteeditar"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editar Valor</span>
                      </v-tooltip>
                      &nbsp;&nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="activarvalor(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura || !item.permiteactivar"
                          >
                            mdi-play
                          </v-icon>
                        </template>
                        <span>Activar Valor</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevovalor" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            {{ dialognuevovalortitulo }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarvalor">
                  Guardar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialognuevovalor = false">
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <br />
            <v-row row wrap>
              <v-col cols="12" md="4" lg="4" class="alineaizquierda">
                <v-text-field
                  v-model="edited.valor"
                  label="Valor"
                  height="20px"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" class="alineaizquierda">
                <v-menu
                  v-model="menufdesde"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfdesde"
                      label="Desde"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="edited.desde"
                    @input="menufdesde = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="alineaizquierda">
                <v-menu
                  v-model="menufhasta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfhasta"
                      label="Hasta"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="edited.hasta"
                    @input="menufhasta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevaref" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            {{ dialognuevareftitulo }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarreferencia">
                  Guardar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialognuevaref = false">
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <br />
            <v-row row wrap>
              <v-col cols="12" md="8" lg="8" class="alineaizquierda">
                <v-text-field
                  v-model="editedref.descripcion"
                  label="Descripción"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" class="alineaizquierda">
                <v-text-field
                  v-model="editedref.mnemo"
                  label="MNemo"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="6" lg="4" class="alineaizquierda">
                <v-menu
                  v-model="menufdesderef"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfdesderef"
                      label="Desde"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedref.desde"
                    @input="menufdesderef = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6" lg="4" class="alineaizquierda">
                <v-menu
                  v-model="menufhastaref"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfhastaref"
                      label="Desde"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedref.hasta"
                    @input="menufhastaref = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "referenciavalores",
  components: {
    ConfirmDlg: ConfirmDlg,
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 59,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      columnasrefe: [
        {
          text: "Op.",
          value: "actions",
          width: 80,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idvalorreferencia",
          width: 40,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 120,
        },
        {
          text: "Mnemo",
          align: "center",
          sortable: true,
          value: "mnemo",
          width: 80,
        },
        {
          text: "Activo",
          align: "center",
          sortable: true,
          value: "activo",
          width: 50,
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desdedmy",
          width: 90,
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hastadmy",
          width: 90,
        }
      ],
      listareferencias: [],
      dialogvalores: false,
      columnasvalores: [
        {
          text: "Op.",
          value: "actions",
          width: 80,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idvalorreferenciavalor",
          width: 40,
        },
        {
          text: "Activo",
          align: "center",
          sortable: true,
          value: "activo",
          width: 50,
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desdedmy",
          width: 90,
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hastadmy",
          width: 90,
        },
        {
          text: "Valor",
          align: "center",
          sortable: true,
          value: "valor",
          width: 80,
        },
        {
          text: "Usuario Carga",
          align: "center",
          sortable: true,
          value: "usuariocarga",
          width: 110,
        },
        {
          text: "Fecha Carga",
          align: "center",
          sortable: true,
          value: "fechacargadmy",
          width: 110,
        },
        {
          text: "Usuario Activo",
          align: "center",
          sortable: true,
          value: "usuarioactivo",
          width: 110,
        },
        {
          text: "Fecha Activo",
          align: "center",
          sortable: true,
          value: "fechaactivodmy",
          width: 110,
        }
      ],
      listavalores: [],
      dialognuevovalor: false,
      dialognuevovalortitulo: '',
      menufdesde: false,
      menufhasta: false,
      edited: {
        idvalorreferenciavalor: 0,
        idvalorreferencia: 0,
        valor: 0,
        activo: true,
        desde: '',
        hasta: '',
        usuario: ''
      },
      idreferenciaeditando: 0,
      dialognuevaref: false,
      dialognuevareftitulo: '',
      menufdesderef: false,
      menufhastaref: false,
      editedref: {
        idvalorreferencia: 0,
        descripcion: '',
        mnemo: '',
        activo: false,
        desde: '',
        hasta: '',
        usuario: ''
      },
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var idrol = localStorage.getItem("rolusuario");
    var roles= localStorage.getItem('rolesusuario')
    var existeper=permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario)  && p.idaccion===1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.", true);
    } else {
      this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
      this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
      this.listarreferencias();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    listarreferencias () {
      axios.post("tesoreria/Postreferenciasvalor", { headers: {"Content-Type": "application/json"}}).then((result) => {
          this.listareferencias = result.data.datos;
          this.loading = false;
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    editar (item) {
      this.loading= true;
      this.dialognuevareftitulo='Editando la Referencia con ID ' + item.idvalorreferencia;
      this.editedref= {
        idvalorreferencia: item.idvalorreferencia,
        descripcion: item.descripcion,
        mnemo: item.mnemo,
        activo: item.activo==='SI' ? true : false,
        desde: item.desdeymd,
        hasta: item.hastaymd,
        usuario: this.usuario
      }
      this.dialognuevaref= true;
      this.loading= false;
    },
    abrirvalores (item) {
      this.loading=true;
      this.idreferenciaeditando= item.idvalorreferencia;
      this.listarvalores();
    },
    listarvalores () {
      axios.post("tesoreria/Postreferenciasvalorvalores",{idreferenciavalor: this.idreferenciaeditando}, { headers: {"Content-Type": "application/json"}}).then((result) => {
        this.listavalores = result.data.datos;
        this.dialogvalores= true;
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    editarvalor (item) {
      this.loading= true;
      this.dialognuevovalortitulo='Editando el Valor con ID ' + item.idvalorreferenciavalor;
      this.edited= {
        idvalorreferenciavalor: item.idvalorreferenciavalor,
        idvalorreferencia: this.idreferenciaeditando,
        valor: item.valor,
        activo: item.activo==='SI' ? true : false,
        desde: item.desdeymd,
        hasta: item.hastaymd,
        usuario: this.usuario
      }
      this.dialognuevovalor= true;
      this.loading= false;
    },
    async activarvalor (item) {
      if (await this.$refs.confirm.open("Activar Valor","¿Está seguro que desea activar el valor? Ya no podrá volver atras el proceso y se cambiarán los saldos de los matriculados.")) {
        this.loading= true;
        axios.post("tesoreria/Postactivarvalorreferencia", {idvalorreferenciavalor: item.idvalorreferenciavalor, usuario: this.usuario}, { headers: { "Content-Type": "application/json" }}).then((result) => {
          if (result.data.resultado === 0) {
            this.listarvalores();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    nuevovalor () {
      this.loading= true;
      this.dialognuevovalortitulo='Editando un nuevo Valor';
      this.edited= {
        idvalorreferenciavalor: 0,
        idvalorreferencia: this.idreferenciaeditando,
        valor: 0.00,
        activo: false,
        desde: this.fechaFormatoymd(new Date()),
        hasta: '',
        usuario: this.usuario
      }
      this.dialognuevovalor= true;
      this.loading= false;
    },
    fechaFormatoymd(date) {
      return ( date.getFullYear() +"-" +((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate())
      );
    },
    guardarvalor () {
      this.loading= true;
      this.edited.valor= parseFloat(this.edited.valor);
      var valido= this.validarvalor();
      if(valido.length===0){
        this.edited.valor= parseFloat(this.edited.valor);

        var reg= this.listavalores.slice();
        const resultadosOrdenados = reg.filter(r=> r.activo==='SI').sort((a,b) => {
          return new Date(b.desdeymd) < new Date(a.desdeymd)
        })
        var valormaxactual= parseFloat(resultadosOrdenados[0].valor);

        if(valormaxactual<parseFloat(this.edited.valor))
        {
          this.guardavalor();
        }else{
          this.loading = false;
          this.MostrarMensaje("Error de Validación", 'El nuevo valor no puede ser menor al actual', false);
        }
      }else{
        this.loading = false;
        this.MostrarMensaje("Error de Validación", valido, false);
      }
    },
    guardavalor() {
      const valor = JSON.stringify(this.edited);
      axios.post("tesoreria/Postagregarvalorreferencia", valor, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if (result.data.resultado === 0) {
          this.dialognuevovalor = false;
          this.listarvalores();
        } else {
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    validarvalor () {
      var valida='';
      if(this.edited.valor<=0)
      {
        valida='Debe ingresar un valor válido mayor a 0';
      }
      if(this.edited.desde===null || this.edited.desde==='') {
        valida='Debe ingresar fecha desde';
      }
      var reg= this.listavalores.slice();
      const resultadosOrdenados = reg.filter(r=> r.activo==='SI').sort((a,b) => {
        return new Date(b.desdeymd) < new Date(a.desdeymd)
      })
      var fechadesdemaxactual= new Date(resultadosOrdenados[0].desdeymd);
      //var valormaxactual= resultadosOrdenados[0].valor;

      if(fechadesdemaxactual>=new Date(this.edited.desde)) {
        valida='Debe ingresar fecha desde mayor a la última activa';
      }

      return valida;
    },
    guardarreferencia () {
      this.loading= true;
      const ref = JSON.stringify(this.editedref);
      axios.post("tesoreria/Postguardarreferencia", ref, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if (result.data.resultado === 0) {
          this.dialognuevaref = false;
          this.listarreferencias();
        } else {
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    nuevoreferencia () {
      this.loading= true;
      this.dialognuevareftitulo='Nueva Referencia';
      this.editedref= {
        idvalorreferencia: 0,
        descripcion: '',
        mnemo: '',
        activo: false,
        desde: this.fechaFormatoymd(new Date()),
        hasta: '',
        usuario: this.usuario
      }
      this.dialognuevaref= true;
      this.loading= false;
    }
},
  computed: {
    fechalocalfdesde: function () {
      if (this.edited.desde != null && this.edited.desde != "") {
        var fecha = new Date(this.edited.desde);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfhasta: function () {
      if (this.edited.hasta != null && this.edited.hasta != "") {
        var fecha = new Date(this.edited.hasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfdesderef: function () {
      if (this.editedref.desde != null && this.editedref.desde != "") {
        var fecha = new Date(this.editedref.desde);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfhastaref: function () {
      if (this.editedref.hasta != null && this.editedref.hasta != "") {
        var fecha = new Date(this.editedref.hasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>